
export const HALO_POINTS_BUILT_IN_TENDER_TYPE = 'HouseAdvantagePoints';
export const HALO_COMP_BUILT_IN_TENDER_TYPE = 'HouseAdvantageComps';
export const HALO_COUPON_BUILT_IN_TENDER_TYPE = 'HouseAdvantageCoupon';

export const isHalo = (tenderType) => {
    return tenderType.builtInTenderType === HALO_POINTS_BUILT_IN_TENDER_TYPE ||
        tenderType.builtInTenderType === HALO_COMP_BUILT_IN_TENDER_TYPE ||
        tenderType.builtInTenderType === HALO_COUPON_BUILT_IN_TENDER_TYPE;
};